import feeReminderLadderService from "@services/feeNotificatiion/feeReminderLadderService"
import type {
  IFeeReminderLadder,
  IFeeReminderLadderCreateOrUpdate,
} from "@models/feeNotification/feeReminderLadderModel"
import { action, makeAutoObservable, observable } from "mobx"

// Req6: store cấu hình thang nhắc phí theo dự án.
class FeeReminderLadderStore {
  @observable isLoading = false
  @observable ladder: IFeeReminderLadder | null = null

  constructor() {
    makeAutoObservable(this)
  }

  @action
  async getByProject(projectId: number) {
    this.isLoading = true
    try {
      const result = await feeReminderLadderService.getListByProject(projectId)
      this.ladder = result?.[0] ?? null
    } finally {
      this.isLoading = false
    }
  }

  @action
  async createOrUpdate(body: IFeeReminderLadderCreateOrUpdate) {
    this.isLoading = true
    try {
      const result = await feeReminderLadderService.createOrUpdate(body)
      this.ladder = result
      return result
    } finally {
      this.isLoading = false
    }
  }

  @action
  async delete(id: number) {
    this.isLoading = true
    try {
      await feeReminderLadderService.delete(id)
      this.ladder = null
    } finally {
      this.isLoading = false
    }
  }

  // Chạy ngay lịch tạo đợt của cấu hình này (chỉ tạo đợt Tạo mới, không gửi).
  @action
  async createBatchesByConfiguration(id: number) {
    this.isLoading = true
    try {
      await feeReminderLadderService.createBatchesByConfiguration(id)
    } finally {
      this.isLoading = false
    }
  }
}

export default FeeReminderLadderStore
